import script from "./LandingSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingSection.vue?vue&type=script&setup=true&lang=js"

import "./LandingSection.vue?vue&type=style&index=0&id=d0320d8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0320d8e"]])

export default __exports__